import React, { useState } from "react";

import FlatCard from "components/UI-lib/FlatCard";
import { LifeCycleScript } from "components/Environment/Create/LifeCycleScript";
import { BeakerIcon } from "@heroicons/react/24/outline";

interface LifecycleScriptConfigurationProps {
  script: string;
  setScript: (script: string) => void;
  lifecycleScriptTab: "upload" | "paste";
  setLifecycleScriptTab: (tab: "upload" | "paste") => void;
  lifecycleScriptFile: File | null;
  setLifecycleScriptFile: (file: File | null) => void;
}

export const LifecycleScriptConfiguration: React.FC<
  LifecycleScriptConfigurationProps
> = ({
  script,
  setScript,
  lifecycleScriptTab,
  setLifecycleScriptTab,
  lifecycleScriptFile,
  setLifecycleScriptFile,
}) => {
  return (
    <div>
      <div className="flex flex-col items-start mb-4">
        <div className="flex flex-row items-center gap-2">
          <h2 className="text-xl font-semibold text-primary">
            Do you want to run a setup script?
          </h2>
        </div>
        <p className="text-secondary text-xs">
          (To skip, leave blank and click next)
        </p>
      </div>

      <LifeCycleScript
        hideTitle={true}
        script={script}
        onSetScript={setScript}
        lifecycleScriptTab={lifecycleScriptTab}
        setLifecycleScriptTab={setLifecycleScriptTab}
        lifecycleScriptFile={lifecycleScriptFile}
        setLifecycleScriptFile={setLifecycleScriptFile}
        saveDescription="Click next to save your script."
      />
    </div>
  );
};
